var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSetting4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M35.3833 12.7H26.15C25.5167 12.7 25 12.1833 25 11.5333C25 10.9 25.5167 10.3833 26.15 10.3833H35.3833C36.0167 10.3833 36.5333 10.9 36.5333 11.5333C36.5333 12.1833 36.0167 12.7 35.3833 12.7Z",
    fill: "#04EEAD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M10.7668 12.6999H4.6168C3.98346 12.6999 3.4668 12.1832 3.4668 11.5499C3.4668 10.9166 3.98346 10.3999 4.6168 10.3999H10.7668C11.4001 10.3999 11.9168 10.9166 11.9168 11.5499C11.9168 12.1832 11.4001 12.6999 10.7668 12.6999Z",
    fill: "#04EEAD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9171 18.0667C20.5254 18.0667 23.4505 15.1416 23.4505 11.5333C23.4505 7.92507 20.5254 5 16.9171 5C13.3089 5 10.3838 7.92507 10.3838 11.5333C10.3838 15.1416 13.3089 18.0667 16.9171 18.0667Z",
    fill: "#1F2937"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M35.383 29.6164H29.233C28.5997 29.6164 28.083 29.0997 28.083 28.4664C28.083 27.8331 28.5997 27.3164 29.233 27.3164H35.383C36.0163 27.3164 36.533 27.8331 36.533 28.4664C36.533 29.0997 36.0163 29.6164 35.383 29.6164Z",
    fill: "#04EEAD"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M13.8501 29.6164H4.6168C3.98346 29.6164 3.4668 29.0997 3.4668 28.4664C3.4668 27.8331 3.98346 27.3164 4.6168 27.3164H13.8501C14.4835 27.3164 15.0001 27.8331 15.0001 28.4664C15.0001 29.0997 14.4835 29.6164 13.8501 29.6164Z",
    fill: "#04EEAD"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0831 34.9998C26.6914 34.9998 29.6165 32.0747 29.6165 28.4664C29.6165 24.8582 26.6914 21.9331 23.0831 21.9331C19.4749 21.9331 16.5498 24.8582 16.5498 28.4664C16.5498 32.0747 19.4749 34.9998 23.0831 34.9998Z",
    fill: "#1F2937"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetting4);
export default __webpack_public_path__ + "static/media/setting-4.12fe0bb4cc98ff014bb4e670ced2fd8f.svg";
export { ForwardRef as ReactComponent };